import React from "react"
import hamburgerIcon from "../../content/assets/hamburger-icon.svg"
import { scale } from "../utils/typography"
import { Link } from "gatsby"
import styles from './layout.module.scss';
import NavPanel from './nav-panel.js';

class Layout extends React.Component {
  constructor() {
    super();
    this.state = {
      hideFullScreenMenu: true,
    };
  }
  render() {
    const { title, children } = this.props;
    let header

    header = (
      <h1
        style={{
          ...scale(1.5),
          marginTop: 0,
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }} to={`/`}
        >
          {title}
        </Link>
      </h1>
    )
    return (
      <div>
        <div className={styles.container}>
          <NavPanel isBlog={this.props.isBlog} isFullScreen={false} />
          <img src={hamburgerIcon} className={styles.hamburgerButton} onClick={this.hamburgerClicked.bind(this)}/>
          <div className={styles.mainContent}>
            <header>{header}</header>
            <hr/>
            <main style={{
              marginBottom: 50,
            }}>{children}</main>
            <div className={styles.bottomSpace}></div>
            <footer>
              Copyright © {new Date().getFullYear()} Political Hack - All Rights Reserved
            </footer>
          </div>
        </div>
        <NavPanel isBlog={this.props.isBlog}
                  isFullScreen={true}
                  isHidden={this.state.hideFullScreenMenu}
                  closeClicked={this.closeClicked.bind(this)}/>
      </div>
    );
  }

  hamburgerClicked() {
    this.setState({ hideFullScreenMenu: false });
  }

  closeClicked() {
    this.setState({ hideFullScreenMenu: true });
  }
}

export default Layout
